<template>
  <div class="l-row">
    <form-group label="Ambiente" :columns="6">
      <select v-model="quotation.shipmentMethod" class="form-select">
        <option :value=null>{{ $t('choose.label') }}</option>
        <option :value="module.identifier" v-for="module in definitionShipmentsInstalled">{{ $t(`${module.identifier}.label`) }}</option>
      </select>
    </form-group>

    <form-group label="URL" :columns="6">
      {{ urlQuotation }}

      <button type="button" @click="copied()" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="urlQuotation">
        <i class="icon icon-copy2"></i>
      </button>
    </form-group>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FormGroup from '@/components/template/FormGroup'
  import cookie from 'vue-cookie'

  export default {
    inject: ['quotationDI'],
    data: () => ({}),
    props: {
      customUrl: {
        type: String,
        required: false
      },
      quotation: {
        type: Object,
        required: true
      },
      marketplace: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionShipmentsInstalled'
      ]),
      urlQuotation () {
        let url = `https://quotation.placemarket.com.br/${this.marketplace}/${cookie.get('merchant')}`

        if (window.location.hostname === 'localhost') {
          url = `http://localhost:4000/${this.marketplace}/${cookie.get('merchant')}`
        }

        if (this.customUrl) {
          url = this.customUrl
        }

        return url
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// QuotationConfiguration.vue?08c49846